import { useState } from "react";
import { authAPI } from "../api/client";
import { useNavigate } from "react-router-dom";
import '../pages/AnimationsAndStyles.css';

export default function OTP({ onVerified }) {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const verify = async () => {
    try {
      const userId = localStorage.getItem("pendingUserId");

      if (!userId) {
        alert("Session expired. Please login again.");
        navigate("/");
        return;
      }

      const res = await authAPI.verifyOTP(userId, otp);

      localStorage.setItem("token", res.data.token);
      localStorage.removeItem("pendingUserId");

      if (onVerified) onVerified();

      navigate("/");

    } catch (err) {
      console.error("OTP verification failed", err);
      alert(err.response?.data?.message || "OTP verification failed");
    }
  };

  return (
    <div className="card">
      <h3>Enter Authenticator Code</h3>

      <input
        maxLength="6"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="6-digit OTP"
      />

      <button onClick={verify}>Verify</button>
    </div>
  );
}

// import { useState } from "react";
// import { authAPI } from "../api/client";
// import { useNavigate } from "react-router-dom";

// export default function OTP({ onVerified }) {
//   const [otp, setOtp] = useState("");
//   const navigate = useNavigate();

//   const verify = async () => {
//     try {
//       const userId = localStorage.getItem("pendingUserId");

//       const res = await authAPI.verifyOTP({
//         userId,
//         otp
//       });

//       // save final JWT
//       localStorage.setItem("token", res.data.token);

//       // cleanup
//       localStorage.removeItem("pendingUserId");

//       if (onVerified) onVerified();

//       // redirect to dashboard
//       navigate("/");

//     } catch (err) {
//       console.error("OTP verification failed", err);
//       alert("Invalid OTP");
//     }
//   };

//   return (
//     <div className="card">
//       <h3>Enter Authenticator Code</h3>

//       <input
//         type="text"
//         maxLength="6"
//         placeholder="6-digit OTP"
//         value={otp}
//         onChange={(e) => setOtp(e.target.value)}
//       />

//       <button onClick={verify}>Verify</button>
//     </div>
//   );
// }

// // import { useState } from "react";
// // import { api } from "../api/client";

// // export default function OTP({ userId, setAuthStep }) {
// //   const [otp, setOtp] = useState("");

// //   const verify = async () => {
// //     const res = await api.post("/auth/verify-otp", {
// //       userId,
// //       otp
// //     });
// //     localStorage.setItem("token", res.data.token);
// //     setAuthStep("dashboard");
// //   };

// //   return (
// //     <div>
// //       <h3>Enter Authenticator Code</h3>
// //       <input
// //         maxLength="6"
// //         onChange={(e) => setOtp(e.target.value)}
// //       />
// //       <button onClick={verify}>Verify</button>
// //     </div>
// //   );
// // }
